import { IPlanLopTinChiReducer } from "./../../reducer-model/lop-tin-chi/IPlanLopTinChiReducer";

import { IPlanLopTinChiActionTypes } from "../../action-types/lop-tin-chi/IPlanLopTinChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IPlanLopTinChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  planLopTinChis: [],
};
export const planLopTinChiReducer = (
  state: IPlanLopTinChiReducer = iniState,
  action: IPlanLopTinChiActionTypes
): IPlanLopTinChiReducer => {
  switch (action.type) {
    case "PLAN_LOP_TIN_CHI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "PLAN_LOP_TIN_CHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        planLopTinChis: action.payload,
      };
    case "PLAN_LOP_TIN_CHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
